<template>
  <v-list subheader>
    <v-subheader v-if="showHeader">{{
      $tc('entetes.adresse', adresses.length + delta)
    }}</v-subheader>
    <v-input :rules="[serveurRule(itemPath)]" hide-details="auto" />

    <slot name="premier" />

    <template v-if="readonly">
      <template v-for="(adresse, index) in adresses">
        <adresseListItem :key="`adresse${index}`" :adresse="adresse" />
      </template>
    </template>
    <template v-else>
      <template v-for="(adresse, index) in adresses">
        <v-menu
          v-model="adresse.modal"
          :close-on-content-click="false"
          max-width="750px"
          transition="scale-transition"
          :key="`adresse${index}`"
          @input="editionAdresse(adresse)"
        >
          <template #activator="{ on, attrs }">
            <adresseListItem
              v-bind="attrs"
              v-on="on"
              :adresse="adresse"
              :rules="[nestedServeurRule(`${itemPath}[${index}]`)]"
              :itemPath="`${itemPath}[${index}]`"
              :analyseDiff="analyseDiff"
            >
              <template #action>
                <v-list-item-action
                  v-if="analyseDiff.supprime[`${itemPath}[${index}]`]"
                >
                  <v-btn
                    icon
                    @click.stop="annulerSuppression(`${itemPath}[${index}]`)"
                  >
                    <v-icon>undo</v-icon>
                  </v-btn>
                </v-list-item-action>

                <v-list-item-action v-else>
                  <v-btn icon @click.stop="supprimerAdresse(adresse, index)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
            </adresseListItem>
          </template>

          <adresseEditeur
            v-model="edition"
            titre="Éditer une adresse"
            :itemPath="`${itemPath}[${index}]`"
            @change="valider(adresse)"
            @annuler="annuler(adresse)"
          />
        </v-menu>
      </template>
      <v-subheader class="d-flex justify-center">
        <v-menu
          v-model="ajout"
          :close-on-content-click="false"
          max-width="750px"
          transition="scale-transition"
          @input="editionAdresse({ libelle: 'Adresse' })"
          v-if="!inscription"
        >
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small outlined color="secondary"
              >Ajouter une adresse</v-btn
            >
          </template>

          <adresseEditeur
            v-model="edition"
            titre="Ajouter une adresse"
            :propositionAdresse="propositionAdresse"
            :adressePropose="adressePropose"
            :titreProposition="titreProposition"
            @change="ajouter()"
            @annuler="annulerAjout"
          />
        </v-menu>
        <v-menu
          v-model="ajout"
          :close-on-content-click="false"
          max-width="750px"
          transition="scale-transition"
          @input="editionAdresse({ libelle: 'Adresse professionnelle' })"
          v-else
        >
          <template #activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small outlined color="secondary"
              >Ajouter une adresse professionnelle</v-btn
            >
          </template>

          <adresseEditeur
            v-model="edition"
            titre="Ajouter une adresse professionnelle"
            @change="ajouter()"
            @annuler="annulerAjout"
          />
        </v-menu>
      </v-subheader>
    </template>
  </v-list>
</template>

<script>
import { copieAdresse } from './adresseUtil.js';
import { defaultDiff } from '@/utils/diff.js';
import ServeurRule from '@/plugins/mixins/ServeurRule';

function copieAdresses(value, avecModal) {
  if (!value) {
    return [];
  }
  const adresses = value.map(t => {
    const out = copieAdresse(
      {
        id: t.id,
      },
      t,
    );

    if (avecModal) {
      out.modal = false;
    }
    return out;
  });
  return adresses;
}

export default {
  mixins: [ServeurRule],
  inject: ['errors'],
  props: {
    propositionAdresse: {
      type: Boolean,
      default: false,
    },
    adressePropose: {
      type: String,
      default: null,
    },
    titreProposition: {
      type: String,
      default: null,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    inscription: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
    },
    readonly: {
      type: Boolean,
    },
    itemPath: {
      type: String,
      default: '',
    },
    analyseDiff: {
      type: Object,
      default: defaultDiff,
    },
    delta: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      adresses: copieAdresses(this.value, true),
      edition: {
        libelle: null,
        ligne1: null,
        ligne2: null,
        ligne3: null,
        codePostal: null,
        ville: null,
        localite: null,
        pays: null,
      },
      ajout: false,
    };
  },
  watch: {
    value(newValue) {
      this.adresses = copieAdresses(newValue);
    },
  },
  methods: {
    editionAdresse(adresse) {
      const edition = {};
      copieAdresse(edition, adresse);
      this.edition = edition;
    },
    valider(adresse) {
      adresse.modal = false;
      copieAdresse(adresse, this.edition);
      this.publier();
    },
    supprimerAdresse(adresse, index) {
      this.adresses.splice(index, 1);
      this.publier();
    },
    annulerSuppression(path) {
      this.$emit('annulerSuppression', path);
    },

    annuler(adresse) {
      adresse.modal = false;
    },
    ajouter() {
      const adresse = copieAdresse(
        {
          id: null,
        },
        this.edition,
      );
      this.adresses.push(adresse);
      this.ajout = false;
      this.publier();
    },
    annulerAjout() {
      this.ajout = false;
    },
    publier() {
      const out = copieAdresses(this.adresses);
      this.$emit('input', out);
    },
  },
};
</script>
